/* eslint-disable jsx-a11y/alt-text */
import React, { PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import parse from "html-react-parser";

import stripHtml from 'string-strip-html';

class TwitterItem extends PureComponent {
  _goTwitter = () => {
    const { id } = this.props.childProps;
    window.open('https://twitter.com/ANIPLUS_SHOP/status/' + id, '', '');
  };
  _goTwitterHome = () => {
    window.open('https://twitter.com/ANIPLUS_SHOP', '', '');
  };
  render() {
    const { postdate, text, store, media } = this.props.childProps;
    const { imgUrl } = this.props;
    let className;
    let flag;
    // let text1;
    let title;
    let rText;

    if (text === null || text === undefined || text === '') {
      title = '【공통】';
      flag = '【공통】';
      rText = 'te4st';
    } else {
      const flagPosS = text.indexOf('【');
      const flagPosL = text.indexOf('】');
      //console.log(flagPosS, flagPosL)
      flag = text.substr(flagPosS, flagPosL + 1);

      //console.log(flag, store)

      if (flag === null || flag === undefined || flag === '') {
        if (store === 'hapjung') {
          flag = '【합정점 공지】';
        } else if (store === 'daejeon') {
          flag = '【대전점 공지】';
        } else if (store === 'gwangju') {
          flag = '【광주점 공지】';
        } else if (store === 'busan') {
          flag = '【부산점 공지】';
        } else {
          flag = '【전 지점】';
        }
      }

      if (store === 'hapjung') {
        if (flag.indexOf('합정점') <= -1) {
          flag = '【합정점 안내】';
        }
      } else if (store === 'daejeon') {
        if (flag.indexOf('대전점') <= -1) {
          flag = '【대전점 안내】';
        }
      } else if (store === 'gwangju') {
        if (flag.indexOf('광주점') <= -1) {
          flag = '【광주점 안내】';
        }
      } else if (store === 'busan') {
        if (flag.indexOf('부산점') <= -1) {
          flag = '【부산점 안내】';
        }
      }

      if (store === 'hapjung') {
        className = 'store_card su_hj';
      } else if (store === 'daejeon') {
        className = 'store_card dj_ja';
      } else if (store === 'gwangju') {
        className = 'store_card gj_cj';
      } else if (store === 'busan') {
        className = 'store_card bs_sm';
      } else {
        if (text.indexOf('합정점') > -1) {
          className = 'store_card su_hj';
        } else if (text.indexOf('대전점') > -1) {
          className = 'store_card dj_ja';
        } else if (text.indexOf('광주점') > -1) {
          className = 'store_card gj_cj';
        } else if (text.indexOf('부산점') > -1) {
          className = 'store_card bs_sm';
        } else {
          className = 'store_card et_et';
        }
      }

      /*
            if(text.indexOf('합정점') > -1) {
                className = 'store_card su_hj'
            } else if(text.indexOf('대전점') > -1) {
                className = 'store_card dj_ja'
            } else if(text.indexOf('광주점') > -1) {
                className = 'store_card gj_cj'
            } else if(text.indexOf('부산점') > -1) {
                className = 'store_card bs_sm'
            } else {
                className = 'store_card et_et'
            }
            */
      const titlePosS = text.indexOf('】');
      const temp = text.substr(titlePosS + 1, text.length);
      // const titlePosL = temp.indexOf("\n\n");
      title = temp.substr(0, 50);
      rText = text.replace(/\n/gi, '<br>');
    }

    const yyyy = postdate.substr(0, 4);
    const mm = postdate.substr(4, 2);
    const dd = postdate.substr(6, 2);

    const wdate = yyyy + '.' + mm + '.' + dd;

    //console.log(media)
    return (
      /* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */
      <div className={className}>
        {/* 카드 상단/ */}
        <div className="store_card_top">
          <span
            className="tag"
            onClick={this._goTwitterHome}
            style={{ cursor: 'pointer' }}
          >
            {flag}
            <i>
              <img src={imgUrl + '/img/store/sns_twt.png'} alt="트위터" />
            </i>
          </span>
        </div>
        {/* 카드 타이틀/ */}

        <div className="store_card_tit">
          <p className="date">
            <span>{wdate}</span>
          </p>
          <p className="tit" onClick={this._goTwitter}>
            {title} ...
          </p>
          {/*<p className="summary" style={{textAlign: 'right', cursor: 'pointer'}} onClick={this._goTwitter}>more</p>*/}
        </div>

        {/* 카드 컨텐츠 내용 */}
        <div
          className="store_card_txt"
          onClick={this._goTwitter}
          style={{ marginTop: -10 }}
        >
          {stripHtml(rText)}
          {/*parse(rText)*/}
          {/*}
                    밀리마스 / 사이드엠 상품이 입고되었습니다.<br/>
                    <br/>
                    - THE@TER WAVE 15 chicAAmor<br/>
                    - GROWING SIGN@L 02 C.FIRST<br/>
                    - THE@TER WAVE 15 chicAAmor<br/>
                    - GROWING SIGN@L 02 C.FIRST<br/>
                    - THE@TER WAVE 15 chicAAmor<br/>
                    - GROWING SIGN@L 02 C.FIRST<br/>
                    <br/>
                    매장 이용에 참고 부탁드립니다.
        */}
        </div>
        {media ? (
          <div className="store_card_thumb" onClick={this._goTwitter}>
            <img src={media} />
          </div>
        ) : null}
        {/* 카드 썸네일/ */}
        {/* media.media ? media.media[0].type === 'photo' ? (
                     <div className="store_card_thumb" onClick={this._goTwitter}>
                         <img src = {media.media[0].media_url_https} />
                     </div> 
                ) : null : null */}
      </div>
    );
  }
}

export default shopContext(withRouter(React.memo(TwitterItem)));
